module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.af7ae505.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = 432
// module chunks = 0